import { Button } from '../ui';

/**
 * Instrucciones para configurar el webhook a mano en el portal de Meta cuando
 * el registro automático falla.
 *
 * GAP-B: antes se fabricaba `https://api.tuneground.com` — un dominio que no
 * existe — y el operador lo copiaba a Meta. Si no sabemos la URL, lo decimos.
 */
export function MetaWebhookHelp({
  message,
  appId,
  webhookUrl,
  verifyToken,
}: {
  message: string;
  appId: string;
  webhookUrl: string | null;
  verifyToken: string | null;
}) {
  return (
    <div data-testid="meta-dashboard-instructions" className="toast toast-warning">
      <div className="toast-description space-y-3">
        <h3 className="font-semibold">{message}</h3>
        <ol className="list-decimal pl-5 space-y-2 text-sm">
          <li>
            Andá a{' '}
            <a
              href="https://developers.facebook.com/apps"
              target="_blank"
              rel="noopener noreferrer"
              className="underline font-medium hover:text-warning-800"
            >
              developers.facebook.com/apps
            </a>{' '}
            y entrá a tu app (App ID: {appId}).
          </li>
          <li>Configurá WhatsApp → Configuración → Webhook → Editar</li>
          <li className="flex items-center gap-2 flex-wrap">
            URL del webhook:{' '}
            {webhookUrl ? (
              <>
                <code className="bg-warning-200 px-2 py-1 rounded text-xs">{webhookUrl}</code>{' '}
                <Button
                  type="button"
                  variant="outline"
                  size="sm"
                  onClick={() => navigator.clipboard.writeText(webhookUrl)}
                >
                  📋 Copiar URL
                </Button>
              </>
            ) : (
              <span className="text-danger-700 font-medium">
                no configurada — pedila al equipo técnico (falta VITE_WEBHOOK_BASE_URL en el build
                del panel)
              </span>
            )}
          </li>
          {verifyToken && (
            <li className="flex items-center gap-2 flex-wrap">
              Verify token:{' '}
              <code className="bg-warning-200 px-2 py-1 rounded text-xs">{verifyToken}</code>{' '}
              <Button
                type="button"
                variant="outline"
                size="sm"
                onClick={() => navigator.clipboard.writeText(verifyToken)}
              >
                📋 Copiar Token
              </Button>
            </li>
          )}
          <li>
            Suscribite al campo de webhook <code>messages</code>.
          </li>
        </ol>
      </div>
    </div>
  );
}
